import React, { useContext } from 'react';
import { Box, Optional, Wrapper } from '@honda-canada/design-system-react';

import AutosHeaderRow from './AutosHeaderRow';
import BottomElementContext from '../Footer/service/BottomElementProvider/BottomElementContext';
import DealerStatusAndHoursMobile from './shared/DealerStatusAndHoursMobile';
import DefaultHeaderRow from './DefaultHeaderRow';
import HeaderContext from './service/HeaderContext';
import HeaderProvider from './service/HeaderProvider';
import MenuMobile from './Mobile';
import StaticProvider from './service/StaticProvider';
import themeStyles from './styles/Header.styles';
import useEventHandler from '../../utils/hooks/useEventHandler';

const Container = themeStyles.apply(Wrapper, 'Container');
const AutosHeaderContainer = themeStyles.apply(Box, 'AutosHeaderContainer');
const Nav = themeStyles.apply(Box, 'Nav');
const HeaderBar = themeStyles.apply(Box, 'HeaderBar');
const MegaMenuMask = themeStyles.apply(Box, 'MegaMenuMask');

const HeaderUI = () => {
  const { headerHiddenOnScroll, headerUnderModelNav } = useContext(BottomElementContext);
  const { activeMenu, gtmTags, navBarRef, isOpenMenu, setActiveMenu, showAutosHeader, styles } =
    useContext(HeaderContext);

  const handleAction = useEventHandler(setActiveMenu);

  return (
    <>
      <Nav
        as="nav"
        tabIndex="-1"
        data-gtm-component-type={gtmTags.type}
        data-testid="header-nav-container"
        {...styles.nav}
        headerHiddenOnScroll={headerHiddenOnScroll}
        headerUnderModelNav={headerUnderModelNav}
        activeMenu={activeMenu}
        isOpenMenu={isOpenMenu}
        ref={navBarRef}
      >
        <HeaderBar {...styles.headerBar}>
          <Optional when={showAutosHeader}>
            <AutosHeaderContainer>
              <AutosHeaderRow />
            </AutosHeaderContainer>
          </Optional>
          <Optional when={!showAutosHeader}>
            <Container>
              <DefaultHeaderRow />
            </Container>
          </Optional>
        </HeaderBar>
        <MenuMobile />
      </Nav>
      <DealerStatusAndHoursMobile />
      <MegaMenuMask onClick={() => handleAction(null)} isOpen={activeMenu} showAutosHeader={showAutosHeader} />
    </>
  );
};

const Header = props => (
  <StaticProvider {...props}>
    <HeaderProvider>
      <HeaderUI />
    </HeaderProvider>
  </StaticProvider>
);

export default Header;
